// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutVideoSection-module--root--2ssKM","playButton":"AboutVideoSection-module--playButton--3C-4A"};